export enum SelectDropdownVariants {
	None = 'none',
	All = 'all'
}
